import React from "react";
import { Link } from "react-router-dom";
import { APP } from "@/config";
import { FOOTER_LINKS } from "@/landingContent";

export default function LandingFooter() {
  return (
    <footer className="border-t border-[var(--ns-border)] bg-[var(--ns-surface)]" data-testid="landing-footer">
      <div className="max-w-6xl mx-auto px-5 py-12">
        <div className="grid gap-8 md:grid-cols-[1.4fr_2fr]">
          <div>
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-xl bg-[var(--ns-primary)] text-white grid place-items-center font-head font-bold">N</div>
              <span className="font-head text-lg font-bold text-[var(--ns-text)]">{APP.name}</span>
            </div>
            <p className="mt-3 text-sm text-[var(--ns-muted)] max-w-xs">{APP.tagline}</p>
          </div>
          <nav aria-label="Footer" className="grid grid-cols-2 sm:grid-cols-3 gap-y-3 gap-x-6 content-start">
            {FOOTER_LINKS.map((l) => (
              <Link key={l.label} to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                className="text-sm text-[var(--ns-muted)] hover:text-[var(--ns-primary)] transition-colors focus-visible:outline-none focus-visible:underline">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="mt-10 pt-6 border-t border-[var(--ns-border)] text-xs text-[var(--ns-subtle)]">
          © {new Date().getFullYear()} {APP.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
